export default "__VITE_ASSET__5819bed2__"